import { log } from 'consoleManager';

const initStoreData = (mainStorageKey, keyName) => {
  const keyNameExist = localStorage.getItem(keyName);
  if (!keyNameExist) {
    localStorage.setItem(keyName, JSON.stringify([]));
    handleAllStoreKeys(mainStorageKey, keyName);
  }
};

const getStoreData = (keyName) => {
  try {
    const storeData = localStorage.getItem(keyName);
    return storeData ? JSON.parse(storeData) : [];
  } catch (e) {
    log(e);
    return [];
  }
};

/**
 * It takes a key and a value, and then it sets the value of the key in localStorage
 * @param key - The key to store the data under.
 * @param value - The value to be stored.
 * @returns after update data return true.
 */
const updateStoreData = (keyName, objData) => {
  localStorage.setItem(keyName, JSON.stringify(objData));
};

/**
 * It removes the data from the local storage.
 * @param key - The key to remove from localStorage.
 */
const removeStoreData = (keyName) => {
  localStorage.removeItem(keyName);
};

const checkStoreData = (mainStorageKey, keyName) => {
  try {
    const sessionKeyExist = localStorage.getItem(keyName);
    if (sessionKeyExist === null) {
      initStoreData(mainStorageKey, keyName);
      return getStoreData(keyName);
    } else {
      return getStoreData(keyName);
    }
  } catch (e) {
    log(e);
  }
};

const handleAllStoreKeys = (mainStorageKey, currentStorageKey) => {
  try {
    if (!localStorage.getItem(mainStorageKey)) {
      localStorage.setItem(mainStorageKey, JSON.stringify([]));
    }
    const allStorageKeysStr = localStorage.getItem(mainStorageKey);
    let allStorageKeys = [];
    allStorageKeys = allStorageKeysStr ? JSON.parse(allStorageKeysStr) : [];
    if (allStorageKeys.indexOf(currentStorageKey) == -1) {
      allStorageKeys.push(currentStorageKey);
    }
    localStorage.setItem(mainStorageKey, JSON.stringify(allStorageKeys));
  } catch (e) {
    log(e);
  }
};

const getKeyNameStoreData = (keyName) => {
  const storeData = localStorage.getItem(keyName);
  return storeData;
};

export {
  initStoreData,
  getStoreData,
  updateStoreData,
  removeStoreData,
  checkStoreData,
  handleAllStoreKeys,
  getKeyNameStoreData,
};
